export const ActionTypes = {
  LOADING: "ADD_COLLABORATORS_LOADING",
  ERROR: "ADD_COLLABORATORS_ERROR",
  SUCCESS: "ADD_COLLABORATORS_SUCCESS",
};
